import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axios";

const initialState = {
  orderFormData: {},
  loading: false,
  categoryLoading: false,
  menuLoading: false,
  error: null,
  orderItems: [],
  merchantsInArea: [],
  merchantMenus: [],
  merchantCategories: [],
  selectedItem: {},
  toggleReviewOrder: false,
  toggleItemDetails: false,
  finalCustomerDetails: {},
  menuDataForEdit: [],
  togglePabiliMap: false,
  pabiliDetails: {},
  checkoutLoading: false,

  pabiliPadalaDetails: {},
  changeDefault: false,
};

export const fetchMercantsInArea = createAsyncThunk(
  "order/area-merchants",
  async (payload, thunkAPI) => {
    try {
      const { data } = await axiosInstance().get(
        `/api/local-merchants/available-merchants?province=${payload.province}&city=${payload.city}`
      );

      return data;
    } catch (error) {
      const { data } = error.response;
      console.log(">>>>> error fetching area merchants");

      return thunkAPI.rejectWithValue(data);
    }
  }
);

export const fetchMerchantCategories = createAsyncThunk(
  "order/merchant-categories",
  async (payload, thunkAPI) => {
    try {
      const { data } = await axiosInstance().get(
        `/api/merchant/menu-category/${payload.merchantId}?status=active&hasMenus=true`
      );

      return data;
    } catch (error) {
      const { data } = error.response;
      console.log(">>>>> error fetching area merchants");

      return thunkAPI.rejectWithValue(data);
    }
  }
);

export const fetchMenus = createAsyncThunk(
  "order/merchant-menus",
  async (payload, thunkAPI) => {
    try {
      let finalData;

      if (payload.searchPattern.length === 0) {
        const { data } = await axiosInstance().get(
          `/api/app/menus/${payload.merchantId}/${payload.categoryId}?page=1&limit=10&user_id=0`
        );

        finalData = data;
      } else {
        const { data } = await axiosInstance().get(
          `/api/app/menus/search?searchPattern=${JSON.stringify(
            payload.searchPattern
          )}&merchant_id=${payload.merchantId}`
        );

        finalData = data;
      }

      return finalData;
    } catch (error) {
      const { data } = error.response;
      console.log(">>>>> error fetching menus of merchant");

      return thunkAPI.rejectWithValue(data);
    }
  }
);

export const placeOrder = createAsyncThunk(
  "order/order-form",
  async (payload, thunkAPI) => {
    try {
      const { data } = await axiosInstance().post("/api/orders", payload);

      return data;
    } catch (error) {
      const { data } = error.response;
      console.log(">>>>> error fetching menus of merchant");

      return thunkAPI.rejectWithValue(data);
    }
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    clearMerchantList: (state) => {
      state.merchantsInArea = [];
    },
    clearCategories: (state) => {
      state.merchantCategories = [];
    },
    clearOrderItems: (state) => {
      state.orderItems = [];
    },
    clearMerchantMenus: (state) => {
      state.merchantMenus = [];
    },
    setOrderFormData: (state, action) => {
      state.orderFormData = { ...state.orderFormData, ...action.payload };
    },
    clearOrderFormData: (state) => {
      state.orderFormData = {};
    },
    clearSelectedItem: (state) => {
      state.selectedItem = [];
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    setOrderItem: (state, action) => {
      const order = state.orderItems;
      const { key, itemToAdd, selectedItem } = action.payload;

      if (key !== null) {
        const itemIndex = order.findIndex((item) => item.key === key);

        if (itemIndex !== -1) {
          order.splice(itemIndex, 1);
        }
      }

      order.push(itemToAdd);

      const existingItem = state.menuDataForEdit.find(
        (item) => item.id === selectedItem.id
      );

      if (!existingItem) {
        state.menuDataForEdit.push(selectedItem);
      }
    },
    setToggleReviewOrder: (state, action) => {
      state.toggleReviewOrder = action.payload;
    },
    setTogglePabiliMap: (state, action) => {
      state.togglePabiliMap = action.payload;
    },
    setPabiliDetails: (state, action) => {
      state.pabiliDetails = action.payload;
    },
    setToggleItemDetails: (state, action) => {
      state.toggleItemDetails = action.payload;
    },
    setFinalCustomerDetails: (state, action) => {
      state.finalCustomerDetails = action.payload;
    },

    setChangeDefault: (state, action) => {
      state.changeDefault = action.payload;
    },

    setPabiliPadalaDetails: (state, action) => {
      state.pabiliPadalaDetails = action.payload;
    },

    removeOrderItem: (state, action) => {
      state.orderItems = state.orderItems.filter(
        (item) => item.key !== action.payload
      );
    },
    clearAll: (state, action) => {
      state.orderFormData = {};
      state.loading = false;
      state.categoryLoading = false;
      state.menuLoading = false;
      state.error = null;
      state.orderItems = [];
      state.merchantsInArea = [];
      state.merchantMenus = [];
      state.merchantCategories = [];
      state.selectedItem = {};
      state.toggleReviewOrder = false;
      state.toggleItemDetails = false;
      state.finalCustomerDetails = {};
      state.menuDataForEdit = [];
      state.togglePabiliMap = false;
      state.pabiliDetails = {};
      state.checkoutLoading = false;
      state.pabiliPadalaDetails = {};
    },
  },
  extraReducers: (builder) => {
    // merchants
    builder
      .addCase(fetchMercantsInArea.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMercantsInArea.fulfilled, (state, action) => {
        state.loading = false;
        state.merchantsInArea = action.payload.result;
      })
      .addCase(fetchMercantsInArea.rejected, (state, action) => {
        state.loading = false;
        state.error = "Something Went Wrong fethcing area merchants";
      })
      // categories
      .addCase(fetchMerchantCategories.pending, (state) => {
        state.merchantCategories = [];
        state.categoryLoading = true;
        state.error = null;
      })
      .addCase(fetchMerchantCategories.fulfilled, (state, action) => {
        state.categoryLoading = false;
        state.merchantCategories = action.payload.categories;
      })
      .addCase(fetchMerchantCategories.rejected, (state) => {
        state.categoryLoading = false;
        state.error = "Something Went Wrong fetching merchants categories";
      })
      // merchant menus
      .addCase(fetchMenus.pending, (state) => {
        state.merchantMenus = [];
        state.menuLoading = true;
        state.error = null;
      })
      .addCase(fetchMenus.fulfilled, (state, action) => {
        state.menuLoading = false;
        state.merchantMenus = action.payload.result;
      })
      .addCase(fetchMenus.rejected, (state) => {
        state.menuLoading = false;
        state.error = "Something Went Wrong fetching merchants categories";
      })
      // place order

      .addCase(placeOrder.pending, (state) => {
        state.checkoutLoading = true;
        state.error = null;
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.checkoutLoading = false;
      })
      .addCase(placeOrder.rejected, (state) => {
        state.checkoutLoading = false;
        state.error = "Something Went Wrong placing order";
      });
  },
});

export const {
  clearMerchantList,
  clearCategories,
  clearMerchantMenus,
  clearOrderItems,
  setOrderFormData,
  clearOrderFormData,
  setSelectedItem,
  setOrderItem,
  clearSelectedItem,
  setToggleReviewOrder,
  setFinalCustomerDetails,
  removeOrderItem,
  setToggleItemDetails,
  setPabiliDetails,
  setTogglePabiliMap,
  clearAll,
  setPabiliPadalaDetails,
  setChangeDefault,
} = orderSlice.actions;

export default orderSlice.reducer;
